document.addEventListener( "DOMContentLoaded", function () {
    let pagination_data = document.getElementById( "load-more-container" );

	if ( ! pagination_data ) {
		return;
	}

    let postContainer = document.getElementById( "post-container" );
    let maxPage       = parseInt( pagination_data.getAttribute( "data-max" ) );
    let loading       = false;

    function loadMorePosts() {
        if ( loading ) return;
        loading = true;

        let nextPage = parseInt( pagination_data.getAttribute( "data-page" ) ) + 1;

        if ( nextPage > maxPage ) {
            pagination_data.style.display = "none";
            return;
        }

        let data = new FormData();
        data.append( "action", "load_more_posts" );
        data.append( "page", nextPage );
		data.append( "nonce", ajax_object.nonce );
		if ( pagination_data.dataset.search ) {
			data.append( "search", pagination_data.dataset.search );
		}
		if ( pagination_data.dataset.category ) {
			data.append( "category", pagination_data.dataset.category );
		}
		if ( document.querySelector( ".vg-loading" ) ) {
			document.querySelector( ".vg-loading" ).style.display = "flex";
		}
        fetch( ajax_object.ajax_url, {
            method : "POST",
            body   : data,
        })
            .then( response => response.text() )
            .then( data => {
                if ( data.trim() !== "" ) {
                    postContainer.insertAdjacentHTML( "beforeend", data );
                    pagination_data.setAttribute( "data-page", nextPage );
					setTimeout( () => {
						check_if_we_have_to_load_more();
					}, 500 );
                } else {
                    pagination_data.style.display = "none";
                }
				if ( document.querySelector( ".vg-loading" ) ) {
					document.querySelector( ".vg-loading" ).style.display = "none";
				}
            })
            .finally( () => {
                loading = false;
            });
    }

	check_if_we_have_to_load_more();

    window.addEventListener( "scroll", function () {
		check_if_we_have_to_load_more();
    });

	function check_if_we_have_to_load_more() {
		let scrollPosition = window.innerHeight + window.scrollY;
        let documentHeight = document.body.offsetHeight;

        if ( scrollPosition >= documentHeight - 300 ) {
            loadMorePosts();
        }
	}
});
